export const smallGroupLessonsIntroSteps = [
  {
    element: '#resources-title',
    intro: 'Small Group Lessons is where you can view videos that provide guidance for small group instruction and how to create a lesson plan. There are also model lesson videos for all different lesson types.'
  },
  {
    element: '.kb-list:last-child wf-knowledge-base-item:last-child',
    intro: 'Click here to view a video that provides an overview of the WordFlight teacher-facilitated small group instruction.'
  },
  {
    element: '.kb-list:last-child wf-knowledge-base-item:nth-last-child(2)',
    intro: 'Click here to view a video that provides guidance on how to create a differentiated weekly unit lesson plan for a group of students.'
  },
  {
    element: 'wf-knowledge-base',
    intro: 'Click on any video to view the model lesson video for the specific lesson type and/or grade level.'
  }
];
